import { render, staticRenderFns } from "./ImageLoader.vue?vue&type=template&id=99d44ffa&scoped=true&"
import script from "./image-loader.js?vue&type=script&lang=js&"
export * from "./image-loader.js?vue&type=script&lang=js&"
import style0 from "./image-loader.scss?vue&type=style&index=0&id=99d44ffa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d44ffa",
  null
  
)

export default component.exports